import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramLogo, TiktokLogo, FacebookLogo } from '@phosphor-icons/react';

const LOGO_URL = 'https://i.imgur.com/8iD261r.jpeg';

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-[#C4A35A]/10 text-[#F0E6D0] pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="CandleCraze" className="h-12 w-12 rounded-md object-cover" />
              <div>
                <p className="font-['Cormorant_Garamond'] text-xl font-semibold leading-tight text-[#E8D5A3]">CandleCraze</p>
                <p className="text-[10px] tracking-[0.15em] uppercase text-[#C4A35A]">Designs & More</p>
              </div>
            </div>
            <p className="text-sm text-[#C4A35A] leading-relaxed italic font-['Cormorant_Garamond'] text-lg">
              Effortless Beauty, Sweetly Done
            </p>
            <p className="text-xs text-[#9A8E7A]/70 mt-3 leading-relaxed">
              Clean-burning soy, coconut-apricot, and white beeswax candles. Hand-poured in Egg Harbor Township, NJ.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="uppercase text-xs tracking-[0.2em] text-[#C4A35A] font-medium mb-4">Shop</h4>
            <div className="space-y-2.5">
              <Link to="/shop?category=candles" className="block text-sm text-[#F0E6D0]/70 hover:text-[#C4A35A] transition-colors" data-testid="footer-candles">Candles</Link>
              <Link to="/shop?category=wax_melts" className="block text-sm text-[#F0E6D0]/70 hover:text-[#C4A35A] transition-colors" data-testid="footer-wax-melts">Wax Melts</Link>
              <Link to="/shop?category=room_sprays" className="block text-sm text-[#F0E6D0]/70 hover:text-[#C4A35A] transition-colors" data-testid="footer-room-sprays">Room & Auto Sprays</Link>
              <Link to="/shop?category=skincare" className="block text-sm text-[#F0E6D0]/70 hover:text-[#C4A35A] transition-colors" data-testid="footer-skincare">Skincare</Link>
              <Link to="/shop?category=lipgloss" className="block text-sm text-[#F0E6D0]/70 hover:text-[#C4A35A] transition-colors" data-testid="footer-lipgloss">Lip Gloss</Link>
              <Link to="/shop" className="block text-sm text-[#F0E6D0]/70 hover:text-[#C4A35A] transition-colors" data-testid="footer-shop-all">Shop All</Link>
            </div>
          </div>

          {/* Connect */}
          <div>
            <h4 className="uppercase text-xs tracking-[0.2em] text-[#C4A35A] font-medium mb-4">Connect</h4>
            <div className="space-y-2.5 mb-6">
              <Link to="/about" className="block text-sm text-[#F0E6D0]/70 hover:text-[#C4A35A] transition-colors" data-testid="footer-about">About Us</Link>
              <a href="https://candlecraze-design.myshopify.com/" target="_blank" rel="noopener noreferrer" className="block text-sm text-[#F0E6D0]/70 hover:text-[#C4A35A] transition-colors" data-testid="footer-shopify">Our Shopify Store</a>
            </div>
            <div className="flex items-center gap-4">
              <a href="https://www.tiktok.com/@cd37220" target="_blank" rel="noopener noreferrer" className="text-[#9A8E7A] hover:text-[#C4A35A] transition-colors" data-testid="footer-tiktok">
                <TiktokLogo size={22} weight="regular" />
              </a>
              <a href="https://www.instagram.com/candlecrazedesignsmore" target="_blank" rel="noopener noreferrer" className="text-[#9A8E7A] hover:text-[#C4A35A] transition-colors" data-testid="footer-instagram">
                <InstagramLogo size={22} weight="regular" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61588334764795" target="_blank" rel="noopener noreferrer" className="text-[#9A8E7A] hover:text-[#C4A35A] transition-colors" data-testid="footer-facebook">
                <FacebookLogo size={22} weight="regular" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#C4A35A]/10 pt-6 text-center">
          <p className="text-xs text-[#9A8E7A]/50">&copy; 2026 CandleCraze Designs & More. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
